import { functions } from '@/config/firebase'

/**
 * Reboot remote dvice with balena.
 * @param {String} deviceId
 * @returns Promite<Object>
 */
const rebootRemoteDevice = async deviceId => {
  const task = functions.httpsCallable('balena-RebootDevice')
  return task({ deviceId })
}

export { rebootRemoteDevice }
